import React, {Component} from 'react';
import '../App.css';
import axios from 'axios';
import cookie from 'react-cookies';

class ChangePwd extends Component{
    //call the constructor method
    constructor(props){
        super(props);
        
        this.state = {
            password : "",
            new_password : "",
            new_confirm_password : "",
            message: ""
        }
        
        this.passwordChangeHandler = this.passwordChangeHandler.bind(this);
        this.newPasswordChangeHandler = this.newPasswordChangeHandler.bind(this);
        this.newConfirmPasswordChangeHandler = this.newConfirmPasswordChangeHandler.bind(this);
        this.submitChangePwd = this.submitChangePwd.bind(this);
    }
    //Call the Will Mount to set the auth Flag to false
    componentWillMount(){
        this.setState({
            authFlag : false
        })
    }
    
    passwordChangeHandler = (e) => {
        this.setState({
            password : e.target.value
        })
    }

    newPasswordChangeHandler = (e) => {
        this.setState({
            new_password : e.target.value
        })
    }

    newConfirmPasswordChangeHandler = (e) => {
        this.setState({
            new_confirm_password : e.target.value
        })
    }

    handleValidation(){
        let formIsValid = true;

        if ( this.state.new_password !== this.state.new_confirm_password ) {
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['pwd_msg_1']
            });
        }

        if(!this.state.new_confirm_password){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['pwd_msg_2']
            });
        }

        //Password
        if(!this.state.new_password){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['pwd_msg_3']
            });
        }

        //Password
        if(!this.state.password){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['pwd_msg_4']
            });
        }

        return formIsValid;
    }
    //submit Login handler to send a request to the node backend
    submitChangePwd = (e) => {
        e.preventDefault();

        if(this.handleValidation()){
            const pwddata = {
                userid: cookie.load('cookieId'),
                password : this.state.password,
                new_password : this.state.new_password
            }
            
            axios.defaults.withCredentials = true;
            
            axios.post(window.$backend_url + '/changePwd',pwddata)
                .then(response => {
                    if(response.status === 200){
                        this.props.closeChangePwdPopup();
                    }
                })
                .catch(error => {
                    this.setState({
                        message : this.props.dataLanguage['pwd_msg_5']
                    });
                })
        }
    }

    render(){
        return(            
            <div className="modal-change-pwd custom-modal">
                <div className="modal-logo">
                    <img alt="logo" src="/assets/images/logo.png" />
                </div>
                <h2 className="text-center">{this.props.dataLanguage['changePwd']}</h2>
                <form className="change-pwd-form">
                    { this.state.message ?
                        <p className="message-text">{ this.state.message }</p>
                    : null }
                    <div className="form-group">
                        <label>{this.props.dataLanguage['oldPwd']}</label>
                        <div className="pwd-container ">
                            <input onChange = {this.passwordChangeHandler} type="password" className="form-control password" name="old_password" ></input>                            
                        </div>
                    </div>
                    <div className="form-group">
                        <label>{this.props.dataLanguage['newPwd']}</label>
                        <div className="pwd-container ">
                            <input onChange = {this.newPasswordChangeHandler} type="password" className="form-control password" name="new_password" ></input>                            
                        </div>
                    </div>
                    <div className="form-group">
                        <label>{this.props.dataLanguage['confirmNewPwd']}</label>
                        <div className="pwd-container ">
                            <input onChange = {this.newConfirmPasswordChangeHandler} type="password" className="form-control password" name="new_password" ></input>                            
                        </div>
                    </div>
                    <button onClick = {this.submitChangePwd} type="submit" className="btn-submit">{this.props.dataLanguage['changePwd']}</button>                     
                </form>
            </div>
        )
    }
}

export default ChangePwd;


// WEBPACK FOOTER //
// ./src/components/ChangePwd.js